import { PortableText } from '@ahmdigital/ui';
import generatePortableText from '@ahmdigital/logic/lib/content/utils/generate-portable-text';
import styled from 'styled-components';

import placeholderSerializer from '../../../serializers/placeholder';
import type { Offer, OfferRewards, Placeholder } from '../../../types';
import type { PortableTextType } from '../../../../../types/sanityInternal';

const PortableTextInline = styled(PortableText)`
  display: inline;

  & > p {
    display: inline;
  }
`;

type OfferBannerHeaderProps = {
  header: PortableTextType;
  offer: Offer;
  placeholders: Placeholder[] | undefined;
  rewards?: OfferRewards;
};

const OfferBannerHeader = ({ header, placeholders, offer, rewards }: OfferBannerHeaderProps) => (
  <PortableTextInline
    typeSerializers={{
      placeholder: placeholderSerializer({
        offer,
        placeholders,
        rewards,
      }),
    }}
    source={generatePortableText(header)}
  />
);

export default OfferBannerHeader;
